<template>
  <div class="card-body pt-0 edge-to-edge" v-if="$gate.isAdmin()">
    <div id="tabel_facturi_primite_wrapper" style="position: relative;">
      <div class="table-responsive">
        <table class="table table-bordered table-striped" role="grid" id="tabel_facturi_primite">
          <thead>
            <tr class="text-uppercase fw-bold">
              <th class="text-center" style="width:32px">
                <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                  <input class="form-check-input" type="checkbox" :checked="selectAllVisibleChecked"
                    @change="onToggleSelectAllVisible($event)" />
                </div>
              </th>
              <th style="width: 50px;">ID</th>
              <th style="width: 30px;"></th>
              <th style="width: 90px;">Data</th>
              <th style="width: 90px;">Data eF</th>
              <th style="width: 90px;">Nr. doc.</th>
              <th style="min-width: 200px;">Furnizor</th>
              <th style="width: 90px;" class="text-end">Valoare</th>
              <th style="width: 80px;" class="text-end">TVA</th>
              <th style="width: 100px;" class="text-end">Total</th>
              <th style="width: 90px;">Stare</th>
              <th style="width: 100px;" class="text-end">Sold</th>
              <th style="width: 90px;">Scadență</th>
              <th style="width: 50px;" class="text-center">TVA-I</th>
              <th style="width: 50px;" class="text-center">RJ</th>
              <th style="width: 70px;" class="text-center">Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="factura in facturi" :key="`fp_${factura.id}`">
              <tr :class="`row-fp-${factura.id}`">
                <td class="text-center">
                  <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                    <input class="form-check-input row-select" type="checkbox" :checked="isSelected(factura.id)"
                      @change="onToggleSelect(factura.id, $event)" />
                  </div>
                </td>
                <td>{{ factura.id }}</td>
                <td class="details-control text-center" style="cursor: pointer;" @click="toggleFacturaDetails(factura)">
                  <i class="fas fa-chevron-down" :class="{ 'rotate-up': expandedRows.includes(factura.id) }"></i>
                </td>
                <td>{{ formatDate(factura.data_doc) || '/' }}</td>
                <td>{{ $filters.formatDate(factura.afp_data_creare) || '/' }}</td>
                <td :data-order="Number(factura.nr_doc) || 0">
                  {{ factura.serie_doc }}{{ factura.nr_doc }}
                </td>
                <td>
                  <div style="position: relative;">
                    <div class="text-truncate-clickable"
                      @click.stop="showFullName(factura.id?.toString().startsWith('anaf_') ? (factura.f_denumire?.match(/cif_emitent=(\d+)/)?.[1] || '-') : (factura.f_denumire || '/'), 'furnizor_' + factura.id)"
                      :title="factura.id?.toString().startsWith('anaf_') ? (factura.f_denumire?.match(/cif_emitent=(\d+)/)?.[1] || '-') : (factura.f_denumire || '/')">
                      {{ factura.id?.toString().startsWith('anaf_')
                        ? (factura.f_denumire?.match(/cif_emitent=(\d+)/)?.[1] || '-')
                        : (factura.f_denumire || '/') }}
                    </div>
                    <!-- Tooltip nested -->
                    <div v-if="tooltipData.visible && tooltipData.activeId === 'furnizor_' + factura.id"
                      class="custom-table-tooltip">
                      {{ tooltipData.text }}
                    </div>
                  </div>
                </td>
                <td class="text-end">{{ formatMoney(factura.intrari_date_valoare) }}</td>
                <td class="text-end">{{ formatMoney(factura.intrari_date_tva) }}</td>
                <td class="text-end" :class="Number(factura.intrari_date_total) < 0 ? 'text-danger fw-bold' : ''">
                  {{ formatMoney(factura.intrari_date_total) }}
                </td>
                <td>
                  <div class="progress h-30px">
                    <div class="progress-bar progress-bar-striped progress-bar-animated text-white fw-bold fs-6 py-2"
                      :class="{
                        'bg-danger': factura.stare === 0 || !factura.stare,
                        'bg-warning': factura.stare === 1,
                        'bg-success': factura.stare === 2
                      }" role="progressbar" :style="{
                        width: factura.stare === 0 || !factura.stare ? '100%' :
                          factura.stare === 1 ? '75%' :
                            '100%'
                      }" :aria-valuenow="factura.stare === 0 || !factura.stare ? 100 :
                        factura.stare === 1 ? 75 : 100" aria-valuemin="0" aria-valuemax="100">
                      {{ factura.stare === 0 || !factura.stare ? 'Restant' :
                        factura.stare === 1 ? 'Achitat parțial' :
                          'Achitat' }}
                    </div>
                  </div>
                </td>
                <td class="text-end fw-bold" :class="Number(factura.sold_factura) > 0 ? 'text-danger' : 'text-success'">
                  {{ formatMoney(factura.sold_factura) }}
                </td>
                <td>{{ formatDate(factura.data_scadenta) || '/' }}</td>
                <td class="text-center">
                  <div
                    class="form-check form-check-custom form-check-success form-check-solid d-inline-flex align-items-center mb-0">
                    <input class="form-check-input" type="checkbox" :checked="!!factura.tva_incasare" disabled />
                  </div>
                </td>
                <td class="text-center">
                  <span v-if="factura.rj_id" class="text-success" title="Înregistrare existentă">✅</span>
                  <span v-else class="text-danger" title="Fără înregistrare">❌</span>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-icon btn-sm btn-light-primary" title="Editează factură"
                    @click.stop="openLucruModal(factura, true)">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>
                  <button type="button" class="btn btn-icon btn-sm btn-light-info ms-1" title="Registru Jurnal"
                    @click.stop="openLucruModal(factura, false)">
                    <i class="fa-solid fa-book"></i>
                  </button>
                  <button type="button" class="btn btn-icon btn-sm btn-light-success ms-1"
                    @click.stop="deschideModalPlata(factura)" title="Plătește">
                    <i class="fa-solid fa-money-bill-wave"></i>
                  </button>
                  <button type="button" class="btn btn-icon btn-sm btn-light-danger ms-1"
                    @click.stop="stergeFactura(factura)" title="Șterge factura">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Tooltip custom removed from here, now nested -->
    <!-- Modal Bootstrap pentru lucru pe factură -->
    <div class="modal fade" id="lucruModalFacturiPrimite" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-xxl-custom modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Lucru pe factură</h5>
            <button type="button" class="btn-close" aria-label="Close" @click="hideLucruModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-4">
              <!-- LEFT: Factura details + products (view or edit mode) -->
              <div class="col-12 col-xl-6">
                <!-- FILE PREVIEW -->
                <div v-if="filePreview" class="mb-3">
                  <div class="fs-6 text-muted mb-2">
                    <i class="fa-solid fa-file-image me-1"></i> Fișier sursă: {{ filePreview.original_name }}
                  </div>
                  <div class="border rounded overflow-hidden bg-white file-preview-container">
                    <img v-if="filePreview.is_image"
                      :src="`/api/administrare/work/fisiere/stream_intrare/${filePreview.file_id}?firma_id=${firmaId}`"
                      class="img-fluid w-100" alt="Preview factură" style="max-height: 350px; object-fit: contain;" />
                    <iframe v-else-if="filePreview.is_pdf"
                      :src="`/api/administrare/work/fisiere/stream_intrare/${filePreview.file_id}?firma_id=${firmaId}`"
                      class="w-100" style="height: 350px; border: none;"></iframe>
                    <div v-else class="p-3 text-center text-muted">
                      <i class="fa-solid fa-file fa-2x mb-2"></i>
                      <div>{{ filePreview.original_name }}</div>
                    </div>
                  </div>
                </div>

                <!-- Toggle button -->
                <div class="d-flex align-items-center mb-3">
                  <button type="button" class="btn btn-sm me-2" :class="editMode ? 'btn-light-primary' : 'btn-primary'"
                    @click="editMode = false">
                    <i class="fa-solid fa-eye me-1"></i> Vizualizare
                  </button>
                  <button type="button" class="btn btn-sm" :class="editMode ? 'btn-primary' : 'btn-light-primary'"
                    @click="activateEditMode">
                    <i class="fa-solid fa-pen-to-square me-1"></i> Editare
                  </button>
                </div>

                <!-- VIEW MODE -->
                <div v-if="!editMode">
                  <div class="mb-4">
                    <div class="fs-6 text-muted mb-2">Detalii factură</div>
                    <div class="border rounded p-3 bg-light">
                      <div class="row mb-2">
                        <div class="col-5 text-muted">ID</div>
                        <div class="col-7">{{ modalFactura?.id ?? '-' }}</div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Serie / Nr.</div>
                        <div class="col-7">{{ (modalFactura?.serie_doc || '') + (modalFactura?.nr_doc || '') }}</div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Data</div>
                        <div class="col-7">{{ formatDate(modalFactura?.data_doc) || '-' }}</div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Data eFactura</div>
                        <div class="col-7">{{ $filters.formatDate(modalFactura?.afp_data_creare) || '-' }}</div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Furnizor</div>
                        <div class="col-7">{{ modalFactura?.f_denumire || '-' }}</div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5 text-muted">Valoare / TVA / Total</div>
                        <div class="col-7">
                          {{ formatMoney(modalFactura?.intrari_date_valoare) }} /
                          {{ formatMoney(modalFactura?.intrari_date_tva) }} /
                          {{ formatMoney(modalFactura?.intrari_date_total) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="d-flex align-items-center mb-2">
                      <div class="fs-6 text-muted me-2">Produse</div>
                      <div v-if="modalLoading" class="spinner-border spinner-border-sm" role="status"><span
                          class="visually-hidden">Loading...</span></div>
                    </div>
                    <div class="modal-products-scroll border rounded">
                      <table class="table table-sm table-striped align-middle mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Denumire / Cont Credit</th>
                            <th class="text-end">Cant.</th>
                            <th class="text-end">Valoare</th>
                            <th class="text-end">TVA</th>
                            <th class="text-end">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="!modalLoading && (!modalProduse || modalProduse.length === 0)">
                            <td colspan="6" class="text-center text-muted py-4">Nu există produse pentru această
                              factură.
                            </td>
                          </tr>
                          <tr v-for="(p, idx) in modalProduse" :key="`p_${idx}`">
                            <td>{{ idx + 1 }}</td>
                            <td>
                              <div class="fw-bold">{{ productName(p) }}</div>

                              <div class="mt-2 d-flex align-items-center">
                                <span class="text-muted small me-2 text-nowrap">Cont Credit:</span>
                                <div style="width: 240px;">
                                  <multiselect v-model="p.cont_credit_obj" :options="planConturi" :searchable="true"
                                    :close-on-select="true" :show-labels="false" :custom-label="pcLabel"
                                    track-by="cod_complet" placeholder="Cont" :disabled="false" :max-height="300"
                                    class="small-text-multiselect"
                                    @update:modelValue="(val) => onProductAccountChange(p, val)">
                                    <template #option="{ option }">
                                      {{ pcLabel(option) }}
                                    </template>
                                  </multiselect>
                                  <div v-if="p.cont_credit_obj && p.cont_credit_obj.descriere" class="text-info mt-1" style="font-size: 0.65rem; line-height: 1.2; font-style: italic;">
                                    {{ p.cont_credit_obj.descriere }}
                                  </div>
                                </div>
                                <div v-if="p.saving" class="spinner-border spinner-border-sm ms-2 text-primary"
                                  role="status">
                                </div>
                              </div>
                            </td>
                            <td class="text-end">{{ productQty(p) }}</td>
                            <td class="text-end">{{ productValue(p) }}</td>
                            <td class="text-end">{{ productTva(p) }}</td>
                            <td class="text-end">{{ productTotal(p) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- EDIT MODE -->
                <div v-else>
                  <div v-if="facturaUtilsLoading" class="text-center p-5">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-muted">Se încarcă editorul...</p>
                  </div>
                  <div v-else>
                    <AdaugaFactura_Intrare v-model="facturaForm" v-model:produse="facturaProduse"
                      :serii-facturi="seriiFacturi" :lista-furnizori="listaFurnizori" :valute="valute"
                      :unitati-masura="unitatiMasura" :tipuri-produse="tipuriProduse" :plan-conturi="planConturi"
                      :cote-tva="coteTva" :firma-id="firmaId">
                    </AdaugaFactura_Intrare>
                    <div class="d-flex justify-content-end mt-3">
                      <button type="button" class="btn btn-success fw-bold" @click="salveazaFacturaActualizata"
                        :disabled="facturaUtilsLoading">
                        <i class="fa-solid fa-check-double me-1"></i>
                        Actualizează factura
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- RIGHT: RJ form -->
              <div class="col-12 col-xl-6">
                <div class="d-flex align-items-center mb-2">
                  <div class="fs-6 text-muted me-2">Înregistrare contabilă (RJ)</div>
                  <span v-if="rjExists" class="badge badge-light-success">Înregistrare existentă</span>
                  <span v-else class="badge badge-light-danger">Fără înregistrare</span>
                </div>
                <form @submit.prevent="submitRJ" autocomplete="off">
                  <alert-error :form="rjForm" />

                  <div class="row g-3">
                    <div class="col-12">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="switchAutoRJ" v-model="useAutoRJ">
                        <label class="form-check-label" for="switchAutoRJ">
                          Postare automată (2 linii: 6xx & 4426 → 401)
                        </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Tip document</label>
                      <multiselect v-model="tipDocObj" :options="tipuriDocument" track-by="id" label="descriere"
                        placeholder="Alege tip" :show-labels="false" :allow-empty="false">
                      </multiselect>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Data document</label>
                      <input type="date" class="form-control" v-model="rjForm.doc_data" />
                      <has-error :form="rjForm" field="doc_data" />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Observații</label>
                      <input type="text" class="form-control" v-model="rjForm.observatii"
                        placeholder="Notițe interne" />
                      <has-error :form="rjForm" field="observatii" />
                    </div>

                    <div class="col-12">
                      <label class="form-label">Furnizor</label>
                      <input type="text" class="form-control" :value="furnizorLabel" disabled />
                      <input type="hidden" v-model="rjForm.furnizor_id" />
                      <has-error :form="rjForm" field="furnizor_id" />
                    </div>

                    <!-- ID-uri informative (readonly) -->
                    <div class="col-12 col-md-4">
                      <label class="form-label text-muted small">ID Furnizor</label>
                      <input type="text" class="form-control form-control-sm bg-light"
                        :value="modalFactura?.id_furnizor || '-'" readonly />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label text-muted small">ID Furnizor RJ</label>
                      <input type="text" class="form-control form-control-sm bg-light" :value="contFurnizorCod || '-'"
                        readonly />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label text-muted small">ID Client RJ</label>
                      <input type="text" class="form-control form-control-sm bg-light" value="-" readonly />
                    </div>

                    <!-- Mesaj dacă deja înregistrat în RJ -->
                    <div v-if="rjExists" class="col-12">
                      <div class="alert alert-info py-2 mb-0">
                        <i class="fa-solid fa-circle-check me-2"></i>
                        <strong>Deja înregistrat în RJ.</strong> Poți vizualiza sau modifica înregistrarea existentă.
                      </div>
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="form-label">Monedă</label>
                      <select class="form-select" v-model="rjForm.moneda">
                        <option value="RON">RON</option>
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                      </select>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Curs</label>
                      <input type="number" step="0.0001" class="form-control text-end" v-model.number="rjForm.curs"
                        :readonly="rjForm.moneda === 'RON'" />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Serie / Nr.</label>
                      <input type="text" class="form-control" :value="`${rjForm.serie_doc}${rjForm.nr_doc}`" readonly />
                    </div>



                    <div class="col-12 col-md-4">
                      <label class="form-label">Valoare (bază)</label>
                      <input type="number" step="0.01" class="form-control text-end" v-model="rjForm.valoare"
                        @input="syncRJTotal" />
                      <has-error :form="rjForm" field="valoare" />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">TVA</label>
                      <input type="number" step="0.01" class="form-control text-end" v-model="rjForm.tva"
                        @input="syncRJTotal" />
                      <has-error :form="rjForm" field="tva" />
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="form-label">Total</label>
                      <input type="number" step="0.01" class="form-control text-end" v-model="rjForm.total" readonly />
                    </div>
                    <!-- Previzualizare pentru modul AUTO -->
                    <div v-if="useAutoRJ" class="col-12">
                      <label class="form-label fw-bold">Linii contabile (AUTO — previzualizare)</label>
                      <table class="table table-sm table-bordered align-middle mb-1">
                        <thead>
                          <tr>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th class="text-end">Sumă</th>
                            <th>Explicație</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="autoPreviewLines.length === 0">
                            <td colspan="4" class="text-center text-muted py-3">Completează valorile pentru a vedea
                              previzualizarea.</td>
                          </tr>
                          <tr v-for="(r, i) in autoPreviewLines" :key="`auto_${i}`">
                            <td>{{ r.debit }}</td>
                            <td>{{ r.credit }}</td>
                            <td class="text-end">{{ Number(r.suma).toLocaleString('ro-RO', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }) }}</td>
                            <td>{{ r.explicatie }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <small class="text-muted">* Previzualizare informativă — la salvare se vor posta exact aceste
                        linii
                        (debit → credit).</small>
                    </div>
                    <!-- Repeater pentru modul MANUAL -->
                    <div v-if="!useAutoRJ" class="col-12">
                      <label class="form-label fw-bold">Linii contabile</label>
                      <table class="table table-sm table-bordered align-middle">
                        <thead>
                          <tr>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th style="width:160px" class="text-end">Sumă</th>
                            <th>Explicație</th>
                            <th style="width:48px"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(linie, idx) in liniiRJ" :key="`rj_${idx}`">
                            <td>
                              <input type="text" class="form-control" v-model="linie.cont_debit"
                                placeholder="ex: 628 sau 401.26" />
                            </td>
                            <td>
                              <input type="text" class="form-control" v-model="linie.cont_credit"
                                placeholder="ex: 401 sau 707.01" />
                            </td>
                            <td>
                              <input type="number" step="0.01" class="form-control text-end"
                                v-model.number="linie.suma" />
                            </td>
                            <td>
                              <input type="text" class="form-control" v-model="linie.explicatie"
                                placeholder="Explicație" />
                            </td>
                            <td class="text-center">
                              <button type="button" class="btn btn-sm btn-light-danger" @click="liniiRJ.splice(idx, 1)">
                                <i class="fa-solid fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <button type="button" class="btn btn-light-primary btn-sm"
                        @click="liniiRJ.push({ cont_debit: '', cont_credit: '', suma: 0, explicatie: '' })">
                        <i class="fa-solid fa-plus"></i> Adaugă linie
                      </button>
                      <small class="text-muted ms-2">Sfat: asigură-te că totalul debitelor = totalul creditelor.</small>
                    </div>

                    <div class="col-12 d-flex justify-content-end gap-2">
                      <button type="button" class="btn btn-light" @click="resetRJ">Reset</button>
                      <button type="submit" class="btn btn-primary" :disabled="savingRJ">
                        <span v-if="savingRJ" class="spinner-border spinner-border-sm me-2" role="status"
                          aria-hidden="true"></span>
                        Salvează RJ
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="hideLucruModal">Închide</button>
          </div>
        </div>
      </div>
    </div>
    <PlataModal v-if="plataModal.visible" :factura="plataModal.factura" :firmaId="firmaId"
      :furnizorId="plataModal.furnizorId" :plataId="plataModal.plataId" :mode="plataModal.mode"
      @close="plataModal.visible = false" @saved="loadFacturi()" />

  </div>
</template>

<script>
import { createApp } from 'vue';
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';
// atenție la cale: componenta e în folderul părinte față de work_components
import IntrariFacturaChild from './Intrari_FacturaChild.vue';
import PlataModal from './PlataModal.vue';
import AdaugaFactura_Intrare from '../facturare_components/AdaugaFactura_Intrare.vue';

export default {
  name: 'FacturiPrimite',
  components: { Multiselect, PlataModal, AdaugaFactura_Intrare },
  props: {
    firmaId: { type: [Number, String], required: true }
  },
  data() {
    return {
      facturi: [],
      selectedRowIds: [],
      expandedRows: [],
      produseCache: {},    // { [idFactura]: rows[] }
      childApps: {},       // { [idFactura]: appInstance }

      // Modal Plata state
      plataModal: {
        visible: false,
        factura: null,
        furnizorId: null,
        plataId: null,
        mode: 'create'
      },

      // Factura Editor state
      editMode: false,
      showFacturaEditor: false,
      filePreview: null, // { file_id, mime, is_image, is_pdf, original_name }
      facturaForm: {
        id: null,
        id_furnizor: null,
        furnizor_obj: null,
        serie_document: null,
        serie_document_obj: null,
        nr_document: '',
        data_emitere: '',
        termen_plata: '',
        valuta: 'RON',
        valuta_obj: null,
        curs_valutar: 1,
        delegat_nume: '',
        delegat_date: '',
        delegat_auto: '',
        intocmit_de: '',
        intocmit_cnp: '',
        informatii_suplimentare: '',
        sold: 0,
      },
      facturaProduse: [],

      // Utils for editor
      seriiFacturi: [],
      listaFurnizori: [],
      valute: [],
      unitatiMasura: [],
      tipuriProduse: [],
      coteTva: [],
      facturaUtilsLoaded: false,
      facturaUtilsLoading: false,
      dtInstance: null,
      dtInitializing: false,
      // modalOpen removed
      modalFactura: null,
      modalProduse: [],
      modalLoading: false,
      rjForm: new Form({
        doc_data: '',
        cont_debit_id: '',
        cont_credit_id: '',
        valoare: '',
        tva: '',
        total: '',
        observatii: '',
        furnizor_id: '',
        cont_credit_sint: '401',
        cont_credit_an: '',
        cont_debit_sint: '628',
        cont_debit_an: '',
        cont_tva_id: '4426',
        id_document: '',
        serie_doc: '',
        nr_doc: '',
        tip_document: 'FACTURA_INTRARE',
        id_tip_document: null,
        moneda: 'RON',
        curs: 1,
        perioada_contabila: '',
        data_efactura: '',
        data_scadenta: ''
      }),
      // Linii contabile pentru modul MANUAL (repeater)
      liniiRJ: [],
      useAutoRJ: true,
      savingRJ: false,
      rjExists: false,
      contFurnizorCod: null, // codul contului furnizor din plan_conturi (ex: 401.500)
      // Tooltip custom
      tooltipData: {
        visible: false,
        text: '',
        activeId: null
      },
      tipuriDocument: [], // Added for Multiselect
      backendPreviewLines: [],
      planConturi: [], // Added
      planConturiPromise: null, // Lock for fetch
    };
  },
  computed: {
    selectAllVisibleChecked() {
      if (!Array.isArray(this.facturi) || this.facturi.length === 0) return false;
      const visibleIds = this.facturi.map(r => r.id);
      return visibleIds.every(id => this.selectedRowIds.includes(id));
    },
    furnizorLabel() {
      const f = this.modalFactura || {};
      const id = f?.id_furnizor ?? '';
      const name = f?.f_denumire || '-';
      return id ? `${name} (ID: ${id})` : name;
    },
    contCreditSugerat() {
      const id = this.modalFactura?.id_furnizor;
      return id ? `401.${id}` : '';
    },
    tipDocObj: {
      get() {
        if (!this.rjForm.id_tip_document && !this.rjForm.tip_document) return null;
        if (this.rjForm.id_tip_document) {
          return this.tipuriDocument.find(t => t.id === this.rjForm.id_tip_document) || null;
        }
        // Fallback by name
        return this.tipuriDocument.find(t => t.descriere === this.rjForm.tip_document) || null;
      },
      set(val) {
        if (val) {
          this.rjForm.id_tip_document = val.id;
          this.rjForm.tip_document = val.descriere;
        } else {
          this.rjForm.id_tip_document = null;
          this.rjForm.tip_document = 'Factura_intrare';
        }
      }
    },
    autoPreviewLines() {
      // Previzualizare read-only pentru modul AUTO

      // 1) Dacă backend-ul ne-a trimis linii generate dinamic (ex. produse separate), le folosim
      if (this.backendPreviewLines && this.backendPreviewLines.length > 0) {
        return this.backendPreviewLines.map(l => ({
          debit: l.cont_debit_cod_complet || l.cont_debit_id,
          credit: l.cont_credit_cod_complet || l.cont_credit_id,
          suma: Number(l.suma_ron || 0),
          explicatie: l.descriere
        }));
      }

      // 2) Fallback: calcul simplu 6xx → 401 și 4426 → 401 (logică veche)
      const v = Number(this.rjForm?.valoare || 0);
      const t = Number(this.rjForm?.tva || 0);
      // Folosim contul existent din plan_conturi (dacă există), altfel fallback la 401.{id_furnizor}
      const credit = this.contFurnizorCod || (this.modalFactura?.id_furnizor ? `401.${this.modalFactura.id_furnizor}` : '401');
      const debit6xx = this.rjForm?.cont_debit_id || '628';
      const contTva = this.rjForm?.cont_tva_id || '4426';
      const rows = [];
      if (v > 0) rows.push({ debit: debit6xx, credit, suma: v, explicatie: 'Cheltuială (bază) ' + (this.rjForm.tip_document || '') });
      if (t > 0) rows.push({ debit: contTva, credit, suma: t, explicatie: 'TVA deductibilă' });
      return rows;
    },
  },
  watch: {
    firmaId: {
      immediate: true,
      handler() {
        this.loadFacturi();
      }
    }
  },
  mounted() {
    this.incarcaPlanConturi();
    // this.loadFacturi() is called by watch immediate
    this.incarcaTipDocument();
  },
  beforeUnmount() {
    try { window.$('#lucruModalFacturiPrimite').modal('hide'); } catch { }
    this.destroyDT();
    Object.values(this.childApps).forEach(app => { try { app.unmount(); } catch { } });
    this.childApps = {};
  },
  methods: {
    deschideModalPlata(factura) {
      this.plataModal.mode = 'create';
      this.plataModal.plataId = null;
      this.plataModal.factura = factura;
      this.plataModal.furnizorId = factura.id_furnizor;
      this.plataModal.visible = true;
    },

    deschideModalEditPlata(plata) {
      this.plataModal.mode = 'edit';
      this.plataModal.plataId = plata.id;
      this.plataModal.factura = this.facturi.find(f => f.id === plata.repartizari?.[0]?.id_factura) || null;
      this.plataModal.furnizorId = plata.id_furnizor || this.plataModal.factura?.id_furnizor;
      this.plataModal.visible = true;
    },

    async confirmaStergerePlata(plata) {
      const result = await Swal.fire({
        title: 'Ești sigur?',
        text: "Ștergerea plății va restaura soldul facturilor repartizate și va șterge nota contabilă din Registrul Jurnal!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Da, șterge!',
        cancelButtonText: 'Anulează'
      });

      if (result.isConfirmed) {
        try {
          await axios.delete(`/api/contabilitate/plati/destroy/${plata.id}`);
          Swal.fire('Șters!', 'Plata a fost ștearsă.', 'success');
          this.loadFacturi();
        } catch (e) {
          console.error(e);
          Swal.fire('Eroare', 'Nu s-a putut șterge plata.', 'error');
        }
      }
    },

    // ===== Helpers =====
    ensureDTReady(cb, attempt = 0) {
      const MAX = 10;
      const $ = window.jQuery || window.$;
      const ready = ($ && $.fn && ($.fn.DataTable || $.fn.dataTable)) || (typeof window !== 'undefined' && window.DataTable);
      if (ready) { cb($); return; }
      if (attempt >= MAX) { console.warn('DataTables not available after wait'); return; }
      setTimeout(() => this.ensureDTReady(cb, attempt + 1), 50);
    },
    destroyDT() {
      if (this.dtInstance && typeof this.dtInstance.destroy === 'function') {
        try { this.dtInstance.destroy(); } catch { }
      }
      this.dtInstance = null;
    },
    formatDate(d) {
      if (!d) return '';
      try { return new Date(d).toLocaleDateString('ro-RO'); } catch { return ''; }
    },
    formatMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
    },
    pcLabel(opt) {
      if (!opt) return '';
      return `${opt.cod_complet} - ${opt.descriere}`;
    },
    statusBadge(stare) {
      const s = String(stare || '').toLowerCase();
      if (['platita', 'plătită', 'achitata', 'achitată', 'paid'].includes(s)) return 'badge badge-light-success';
      if (['neplatita', 'neplătită', 'unpaid', 'restanta', 'restanță'].includes(s)) return 'badge badge-light-danger';
      return 'badge badge-light';
    },
    isSelected(id) {
      return this.selectedRowIds.includes(id);
    },
    onToggleSelect(id, ev) {
      const checked = !!(ev && ev.target && ev.target.checked);
      const idx = this.selectedRowIds.indexOf(id);
      if (checked && idx === -1) this.selectedRowIds.push(id);
      if (!checked && idx !== -1) this.selectedRowIds.splice(idx, 1);
    },
    onToggleSelectAllVisible(ev) {
      const checked = !!(ev && ev.target && ev.target.checked);
      const visibleIds = (this.facturi || []).map(r => r.id);
      if (checked) {
        this.selectedRowIds = Array.from(new Set([...this.selectedRowIds, ...visibleIds]));
      } else {
        this.selectedRowIds = this.selectedRowIds.filter(id => !visibleIds.includes(id));
      }
    },
    incarcaTipDocument() {
      // Excludem tip 2 (Iesiri/Factura Iesire)
      axios.get('/api/administrare/work/utils/tipuri-documente', { params: { tip: '1,3,4,5' } })
        .then(r => {
          this.tipuriDocument = r.data || [];
        })
        .catch(e => console.error("Error fetching doc types:", e));
    },

    // ===== Data loading =====
    async loadFacturi() {
      if (!this.firmaId) return;
      try {
        const res = await axios.get('/api/administrare/work/incarcaFacturiPrimite', { params: { firma_id: this.firmaId } });
        const text = 'DataTables'; // avoid lint

        // Destroy BEFORE updating Vue data
        const $tbl = $('#tabel_facturi_primite');
        if ($.fn.DataTable && $.fn.DataTable.isDataTable($tbl)) {
          // We use simple destroy() to detach events. 
          // We do catch because sometimes it might fail if dom is weird.
          try { $tbl.DataTable().destroy(); } catch (e) { }
        }

        this.facturi = Array.isArray(res.data) ? res.data : (res.data.facturi || []);

        this.$nextTick(() => {
          if (!$tbl.length) return;

          // Safety: ensure it is not initialized
          if ($.fn.DataTable.isDataTable($tbl)) {
            $tbl.DataTable().destroy();
          }

          // date flow sorter definition logic...
          $.fn.dataTable.ext.type.order['date-eu-pre'] = function (date) {
            if (!date) return 0;
            const parts = date.split('.');
            return Date.parse(`${parts[2]}-${parts[1]}-${parts[0]}`);
          };

          const vm = this;
          $tbl.DataTable({
            pageLength: 15,
            lengthChange: false,
            columnDefs: [
              { targets: 0, responsivePriority: 1 },
              { targets: 3, type: 'date-eu' } // shifted from 2
            ],
            order: [[3, 'desc']], // shifted from 2
            buttons: ['disable'],
            language: { url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json' },
            paging: true,
            ordering: true,
            info: true,
            searching: true,
            responsive: false,
            autoWidth: false,
            //scrollX: true,
            createdRow: function (row, data, dataIndex) {
              const factura = vm.facturi[dataIndex];
              if (factura && factura.id) {
                $(row).addClass(`row-fp-${factura.id}`);
              }
            }
          });
        });
      } catch (e) {
        console.error('Eroare la încărcarea facturilor primite:', e);
        this.facturi = [];
        this.$nextTick(() => {
          const $tbl = $('#tabel_facturi_primite');
          if ($.fn.DataTable.isDataTable($tbl)) $tbl.DataTable().destroy();
          $tbl.DataTable({ responsive: false });
        });
      }
    },

    // Incarca plan conturi pentru dropdown produse
    async incarcaPlanConturi() {
      if (this.planConturi.length > 0) return;

      // Prevent concurrent requests
      if (this.planConturiPromise) {
        await this.planConturiPromise;
        return;
      }

      if (!this.firmaId) return;

      this.planConturiPromise = (async () => {
        try {
          const res = await axios.get(`/api/administrare/work/utils/plan-conturi/${this.firmaId}`);
          this.planConturi = res.data || [];
        } catch (e) {
          console.error('Err plan conturi', e);
        } finally {
          this.planConturiPromise = null;
        }
      })();

      await this.planConturiPromise;
    },

    initDT() {
      // no-op: initializarea DataTable se face direct in loadFacturi(), similar cu ListaFacturi.vue
    },

    // ===== Child row =====
    async incarcaProduseFactura(id) {
      try {
        const response = await axios.get(`/api/administrare/work/incarcaFacturiPrimite/${id}`);
        const data = Array.isArray(response.data)
          ? response.data
          : (response.data?.produse || response.data?.items || response.data?.rows || []);
        this.produseCache = { ...this.produseCache, [id]: data };
        return data;
      } catch (error) {
        console.error(`Eroare la încărcarea produselor pentru factura primită ${id}:`, error);
        this.produseCache = { ...this.produseCache, [id]: [] };
        return [];
      }
    },

    toggleFacturaDetails(factura) {
      const $ = window.jQuery || window.$;
      const table = $ && $.fn && $.fn.DataTable ? $('#tabel_facturi_primite').DataTable() : null;
      if (!table) return;

      const tr = $(`.row-fp-${factura.id}`);
      const row = table.row(tr);

      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass('shown');
        this.expandedRows = this.expandedRows.filter(id => id !== factura.id);
        const inst = this.childApps[factura.id];
        if (inst && typeof inst.unmount === 'function') {
          try { inst.unmount(); } catch { }
        }
        delete this.childApps[factura.id];
        return;
      }

      const mountChild = (items) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'dt-row-child';
        const app = createApp(IntrariFacturaChild, {
          factura,
          produse: items || [],
          onEditPlata: (p) => this.deschideModalEditPlata(p),
          onDeletePlata: (p) => this.confirmaStergerePlata(p)
        });
        app.mount(wrapper);
        this.childApps[factura.id] = app;
        row.child(wrapper).show();
        tr.addClass('shown');
        if (!this.expandedRows.includes(factura.id)) this.expandedRows.push(factura.id);
      };

      row.child('<div class="p-3 text-muted">Se încarcă produsele...</div>').show();
      tr.addClass('shown');

      if (this.produseCache[factura.id]) {
        mountChild(this.produseCache[factura.id]);
      } else {
        this.incarcaProduseFactura(factura.id).then(() => {
          const items = this.produseCache[factura.id] || [];
          mountChild(items);
        });
      }
    },

    async openLucruModal(factura, startInEditMode = false) {
      this.editMode = !!startInEditMode;
      this.modalFactura = factura || null;
      this.modalLoading = true;
      this.modalProduse = [];
      this.liniiRJ = [];
      this.rjExists = false;
      this.backendPreviewLines = [];
      this.filePreview = null;

      try {
        const id = factura?.id;

        // Fetch file preview (non-blocking)
        if (id) {
          axios.get(`/api/administrare/work/facturi/fisier-preview/intrare/${id}`, {
            params: { firma_id: this.firmaId }
          }).then(res => {
            if (res.data?.status === 'found') {
              this.filePreview = res.data;
            }
          }).catch(() => { /* silent */ });
        }

        // Ensure planConturi is loaded for hydration
        await this.incarcaPlanConturi();

        // 1) Încărcăm produsele facturii
        try {
          if (id) {
            // Always fetch fresh products so cont_credit is up-to-date
            const items = await this.incarcaProduseFactura(id);

            // Hydrate BEFORE assigning to reactive state
            this.hydrateProducts(items || []);

            this.modalProduse = items || [];
          }
        } catch (e) {
          console.error('Eroare la încărcarea produselor pentru modal:', e);
          this.modalProduse = [];
        }

        // 2) Încercăm să încărcăm înregistrarea din Registru Jurnal, dacă există
        if (id && this.firmaId) {
          try {
            const resp = await axios.get('/api/administrare/work/reg-jurnal/factura-primita', {
              params: {
                firma_id: this.firmaId,
                document_id: id,
                tip_document: factura.tip_document || 'Factura_intrare'
              }
            });

            if (resp.data && resp.data.exists) {
              this.rjExists = true;
              const a = resp.data.antet || {};
              const docDateRaw = a.doc_data || factura.data_doc || null;
              const docDate = docDateRaw ? new Date(docDateRaw) : new Date();

              // Antet RJ din baza de date
              this.rjForm.doc_data = docDate.toISOString().slice(0, 10);
              this.rjForm.observatii = a.observatii || '';
              this.rjForm.furnizor_id = a.id_furnizor || factura.id_furnizor || '';
              this.rjForm.moneda = a.moneda || 'RON';
              this.rjForm.curs = a.curs || 1;
              this.rjForm.serie_doc = a.doc_serie || factura.serie_doc || '';
              this.rjForm.nr_doc = a.doc_numar || factura.nr_doc || '';
              this.rjForm.nr_doc = a.doc_numar || factura.nr_doc || '';
              this.rjForm.nr_doc = a.doc_numar || factura.nr_doc || '';
              this.rjForm.tip_document = a.tip_document || factura.tip_document || 'Factura_intrare';
              this.rjForm.id_tip_document = a.id_tip_document || null;
              this.rjForm.id_document = a.id_document || factura.id || '';
              this.rjForm.id_document = a.id_document || factura.id || '';
              this.rjForm.perioada_contabila =
                a.perioada_contabila ||
                `${docDate.getFullYear()}-${String(docDate.getMonth() + 1).padStart(2, '0')}`;
              this.rjForm.data_efactura = a.data_efactura || factura.afp_data_creare || '';
              this.rjForm.data_scadenta = a.data_scadenta || factura.data_scadenta || '';

              const baza = a.valoare_baza != null
                ? Number(a.valoare_baza)
                : Number(factura.intrari_date_valoare || 0);
              const tva = a.valoare_tva != null
                ? Number(a.valoare_tva)
                : Number(factura.intrari_date_tva || 0);
              const total = a.valoare_total != null
                ? Number(a.valoare_total)
                : Number(factura.intrari_date_total || (baza + tva));

              this.rjForm.valoare = baza ? baza.toFixed(2) : '';
              this.rjForm.tva = tva ? tva.toFixed(2) : '';
              this.rjForm.total = total ? total.toFixed(2) : '';
              this.rjForm.cont_tva_id = this.rjForm.cont_tva_id || '4426';

              // Liniile RJ existente (modul MANUAL) — 1:1 cu structura din DB (debit/credit)
              this.liniiRJ = (resp.data.linii || []).map(l => ({
                cont_debit: l.cont_debit || '',
                cont_credit: l.cont_credit || '',
                suma: Number(l.suma || 0),
                explicatie: l.explicatie || ''
              }));

              // Dacă avem linii în RJ -> comutăm automat pe modul MANUAL
              this.useAutoRJ = this.liniiRJ.length === 0;

              // Dacă, din orice motiv, nu există linii, facem prefill standard (AUTO)
              if (this.useAutoRJ) {
                this.prefillRJForm();
              }
            } else {
              // Nu există RJ pentru această factură -> prefill ca înainte (AUTO)
              this.rjExists = false;
              this.useAutoRJ = true;
              // Preluăm contul furnizor existent din plan_conturi (dacă există)
              this.contFurnizorCod = resp.data.cont_furnizor_cod || null;
              // Preluăm liniile de preview generate de backend (dacă există)
              this.backendPreviewLines = resp.data.linii_preview || [];

              this.prefillRJForm();
            }
          } catch (err) {
            console.error('Eroare la încărcarea RJ pentru factură:', err);
            this.rjExists = false;
            this.useAutoRJ = true;
            this.prefillRJForm();
          }
        } else {
          // Nu avem id factură sau firmă validă -> fallback la prefill
          this.useAutoRJ = true;
          this.prefillRJForm();
        }
      } finally {
        this.modalLoading = false;
        try {
          window.$('#lucruModalFacturiPrimite').modal('show');
        } catch (e) {
          const modalEl = document.getElementById('lucruModalFacturiPrimite');
          if (window.bootstrap && modalEl) {
            const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
            modal.show();
          }
        }

        // If starting in edit mode, load editor data
        if (startInEditMode && factura?.id) {
          this.activateEditMode()
        }
      }
    },

    async activateEditMode() {
      this.editMode = true
      const factura = this.modalFactura
      if (!factura || !factura.id) return

      this.facturaUtilsLoading = true
      try {
        // Load utils if not already loaded
        if (!this.facturaUtilsLoaded) {
          await this.loadFacturaUtils()
        }

        // Load full invoice details for the editor
        const { data } = await axios.get(`/api/administrare/work/facturi/intrare/detalii/${factura.id}`, {
          params: { firma_id: this.firmaId }
        })
        if (data.status === 'success') {
          const f = data.factura
          this.facturaForm = {
            id: f.id,
            id_furnizor: f.id_furnizor != null ? Number(f.id_furnizor) : null,
            furnizor_obj: this.listaFurnizori.find(fu => Number(fu.id) === Number(f.id_furnizor)) || null,
            serie_document: f.serie_doc,
            serie_document_obj: this.seriiFacturi.find(s => s.text === f.serie_doc),
            nr_document: f.nr_doc,
            data_emitere: f.data_doc,
            termen_plata: f.data_scadenta,
            valuta: f.id_valuta || 'RON',
            valuta_obj: this.valute.find(v => v.id === f.id_valuta),
            curs_valutar: f.curs || 1,
            delegat_nume: f.delegat,
            delegat_date: f.delegat_cnp,
            delegat_auto: f.delegat_auto,
            intocmit_de: f.nume,
            intocmit_cnp: f.cnp,
            informatii_suplimentare: f.informatii_suplimentare,
            sold: f.sold || 0
          }
          this.facturaProduse = data.produse.map(p => ({
            id: p.id,
            pozitie: p.pozitie,
            id_produs: p.id_produs,
            denumire: p.denumire,
            cota_tva: p.cota_tva,
            um: p.unitate_masura,
            cantitate: p.cantitate,
            pret: p.pret_unitar,
            valoare: p.valoare,
            valoare_tva: p.tva,
            total: p.total,
            cont_debit: p.cont_debit,
            cont_credit: p.cont_credit
          }))
        }
      } catch (e) {
        console.error('Error loading editor data:', e)
        this.$swal.fire('Eroare', 'Nu s-au putut încărca detaliile facturii pentru editare.', 'error')
        this.editMode = false
      } finally {
        this.facturaUtilsLoading = false
      }
    },

    productName(p) {
      return (p?.denumire || p?.nume || p?.name || p?.description || p?.descriere || '-');
    },
    productQty(p) {
      const q = Number(p?.cantitate ?? p?.qty ?? p?.quantity ?? 0);
      return q ? q.toLocaleString('ro-RO', { maximumFractionDigits: 4 }) : '0';
    },
    productPrice(p) {
      const v = Number(p?.pret ?? p?.price ?? 0);
      return this.formatMoney(v);
    },
    productValue(p) {
      const v = Number(p?.valoare ?? p?.value ?? p?.line_value ?? 0);
      return this.formatMoney(v);
    },
    productTva(p) {
      const v = Number(p?.tva ?? p?.vat ?? 0);
      return this.formatMoney(v);
    },
    productTotal(p) {
      const v = Number(p?.total ?? (Number(p?.valoare ?? 0) + Number(p?.tva ?? 0)));
      return this.formatMoney(v);
    },

    hideLucruModal() {
      try { window.$('#lucruModalFacturiPrimite').modal('hide'); } catch (e) {
        const modalEl = document.getElementById('lucruModalFacturiPrimite');
        if (window.bootstrap && modalEl) {
          const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
          modal.hide();
        }
      }
      // Resetăm state-ul
      this.contFurnizorCod = null;
      this.backendPreviewLines = [];
      this.rjExists = false;
    },

    saveLucruModal() {
      this.hideLucruModal();
    },
    prefillRJForm() {
      const f = this.modalFactura || {};
      const value = Number(f?.intrari_date_valoare || 0);
      const tva = Number(f?.intrari_date_tva || 0);
      const total = Number(f?.intrari_date_total || (value + tva));
      this.rjForm.doc_data = (f?.data_doc ? new Date(f.data_doc).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10));
      this.rjForm.cont_debit_sint = '628';
      this.rjForm.cont_debit_an = '';
      this.updateContDebit();
      this.rjForm.cont_credit_sint = '401';
      this.rjForm.cont_credit_an = (f?.id_furnizor ? String(f.id_furnizor) : '');
      this.updateContCredit();
      this.rjForm.valoare = value ? value.toFixed(2) : '';
      this.rjForm.tva = tva ? tva.toFixed(2) : '';
      this.rjForm.total = total ? total.toFixed(2) : '';
      this.rjForm.observatii = '';
      this.rjForm.furnizor_id = f?.id_furnizor || '';   // ✅ nou
      this.rjForm.cont_tva_id = '4426';
      // Antet RJ
      this.rjForm.id_document = f?.id || '';
      this.rjForm.serie_doc = f?.serie_doc || '';
      this.rjForm.nr_doc = f?.nr_doc || '';
      this.rjForm.serie_doc = f?.serie_doc || '';
      this.rjForm.nr_doc = f?.nr_doc || '';
      this.rjForm.tip_document = f?.tip_document || 'Factura_intrare';
      this.rjForm.moneda = 'RON';
      this.rjForm.moneda = 'RON';
      this.rjForm.curs = 1;
      const d = (f?.data_doc ? new Date(f.data_doc) : new Date());
      this.rjForm.perioada_contabila = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      this.rjForm.data_efactura = f?.afp_data_creare || '';
      this.rjForm.data_scadenta = f?.data_scadenta || '';
      this.rjForm.data_scadenta = f?.data_scadenta || '';

      // Prefill linii pentru modul MANUAL
      this.liniiRJ = [];

      // A) Dacă avem preview din backend (linii detaliate pe produse)
      if (this.backendPreviewLines && this.backendPreviewLines.length > 0) {
        this.liniiRJ = this.backendPreviewLines.map(l => ({
          cont_debit: l.cont_debit_cod_complet || l.cont_debit_id,
          cont_credit: l.cont_credit_cod_complet || l.cont_credit_id,
          suma: Number(l.suma_ron || 0),
          explicatie: l.descriere || ''
        }));
        return;
      }

      // B) Fallback: logică simplă (Baza 628 + TVA 4426)
      const _v = Number(this.rjForm.valoare || 0);
      const _t = Number(this.rjForm.tva || 0);
      const credit401 = this.modalFactura?.id_furnizor
        ? `401.${this.modalFactura.id_furnizor}`
        : (this.rjForm.cont_credit_id || '401');
      const debit6xx = this.rjForm.cont_debit_id || '628';
      const contTva = this.rjForm.cont_tva_id || '4426';

      if (_v > 0) {
        this.liniiRJ.push({
          cont_debit: debit6xx,
          cont_credit: credit401,
          suma: _v,
          explicatie: 'Cheltuială (bază)'
        });
      }
      if (_t > 0) {
        this.liniiRJ.push({
          cont_debit: contTva,
          cont_credit: credit401,
          suma: _t,
          explicatie: 'TVA deductibilă'
        });
      }
    },
    updateContCredit() {
      const s = (this.rjForm.cont_credit_sint || '').toString().trim();
      const a = (this.rjForm.cont_credit_an || '').toString().trim();
      this.rjForm.cont_credit_id = s && a ? `${s}.${a}` : (s || a || '');
    },
    updateContDebit() {
      const s = (this.rjForm.cont_debit_sint || '').toString().trim();
      const a = (this.rjForm.cont_debit_an || '').toString().trim();
      this.rjForm.cont_debit_id = s && a ? `${s}.${a}` : (s || a || '');
    },
    syncRJTotal() {
      const v = parseFloat(this.rjForm.valoare || 0) || 0;
      const t = parseFloat(this.rjForm.tva || 0) || 0;
      this.rjForm.total = (v + t).toFixed(2);
    },
    resetRJ() {
      this.prefillRJForm();
    },
    async submitRJ() {
      try {
        this.savingRJ = true;

        const errs = [];
        const v = parseFloat(this.rjForm.valoare || 0) || 0;
        const t = parseFloat(this.rjForm.tva || 0) || 0;
        const tot = parseFloat(this.rjForm.total || 0) || 0;

        // Validări comune
        if (!this.rjForm.doc_data) errs.push('Data document este obligatorie.');
        if (!this.rjForm.furnizor_id) errs.push('Furnizorul nu este setat.');
        if (this.rjForm.moneda !== 'RON' && (!this.rjForm.curs || this.rjForm.curs <= 0)) errs.push('Cursul valutar trebuie setat pentru monedă ≠ RON.');
        // Limităm validarea v+t=tot doar la AUTO
        if (this.useAutoRJ && +(v + t).toFixed(2) !== +tot.toFixed(2)) errs.push(`Balanța nu este egală (Debit ${(v + t).toFixed(2)} ≠ Credit ${tot.toFixed(2)}).`);

        // Validări specifice modului MANUAL
        if (!this.useAutoRJ) {
          // Validări pentru repeater (MANUAL)
          if (!Array.isArray(this.liniiRJ) || this.liniiRJ.length === 0) {
            errs.push('Adaugă cel puțin o linie contabilă.');
          } else {
            const invalid = this.liniiRJ.find(l =>
              !l ||
              !(Number(l.suma) > 0) ||
              (!l.cont_debit && !l.cont_credit)
            );
            if (invalid) {
              errs.push('Toate liniile trebuie să aibă cel puțin un cont (debit sau credit) și o sumă > 0.');
            }
            const sumD = this.liniiRJ.reduce((a, l) => a + ((l.cont_debit ? Number(l.suma) || 0 : 0)), 0);
            const sumC = this.liniiRJ.reduce((a, l) => a + ((l.cont_credit ? Number(l.suma) || 0 : 0)), 0);
            if (+sumD.toFixed(2) !== +sumC.toFixed(2)) {
              errs.push(`Balanța liniilor nu este egală (D ${sumD.toFixed(2)} ≠ C ${sumC.toFixed(2)}).`);
            }
          }
        }

        if (errs.length) {
          Swal.fire({ icon: 'error', title: 'Eroare!', html: `<ul class="text-start mb-0">${errs.map(e => `<li>${e}</li>`).join('')}</ul>` });
          return;
        }

        // Antet comun
        const antet = {
          id_firma: this.firmaId,
          id_document: this.rjForm.id_document,
          tip_document: this.rjForm.tip_document,
          id_tip_document: this.rjForm.id_tip_document,
          serie_doc: this.rjForm.serie_doc,
          nr_doc: this.rjForm.nr_doc,
          data_doc: this.rjForm.doc_data,
          data_efactura: this.rjForm.data_efactura || null,
          data_scadenta: this.rjForm.data_scadenta || null,
          moneda: this.rjForm.moneda,
          curs: this.rjForm.curs,
          perioada_contabila: this.rjForm.perioada_contabila,
          id_furnizor: this.rjForm.furnizor_id,
          valoare_baza: v,
          valoare_tva: t,
          valoare_total: tot,
          observatii: this.rjForm.observatii || ''
        };

        if (this.useAutoRJ) {
          // AUTO mode: folosim endpointul unificat cu flag-ul auto
          // optional: trimitem override pentru conturile implicite dacă utilizatorul a completat
          const antetAuto = {
            ...antet,
            cont_debit: this.rjForm.cont_debit_id || undefined,
            cont_tva: this.rjForm.cont_tva_id || undefined,
          };
          const { data } = await axios.post('/api/administrare/work/reg-jurnal/save', { auto: true, antet: antetAuto });
          const msg = (data && (data.message || data.msg)) || 'Înregistrarea a fost salvată (automat).';
          Swal.fire({ icon: 'success', title: 'Salvat', text: msg });
          this.hideLucruModal();
          // Refresh tabelul pentru a actualiza coloana RJ
          this.loadFacturi();
        } else {
          // MANUAL mode: recalculăm antetul pe baza liniilor introduse
          // Recalculăm sumele pe baza liniilor introduse
          const sumD = this.liniiRJ.reduce((a, l) => a + ((l.cont_debit ? Number(l.suma) || 0 : 0)), 0);
          const sumC = this.liniiRJ.reduce((a, l) => a + ((l.cont_credit ? Number(l.suma) || 0 : 0)), 0);
          // TVA = suma liniilor unde contul de debit începe cu 4426; Bază = restul debitelor
          const tvaFromLines = this.liniiRJ
            .filter(l => typeof l.cont_debit === 'string' && l.cont_debit.trim().startsWith('4426'))
            .reduce((a, l) => a + (Number(l.suma) || 0), 0);
          const bazaFromLines = sumD - tvaFromLines;
          const totalFromLines = sumD; // = sumC, deja validat mai sus

          // suprascriem antetul cu valorile din linii, pentru a evita neconcordanțele
          const antetManual = {
            ...antet,
            valoare_baza: Number(bazaFromLines.toFixed(2)),
            valoare_tva: Number(tvaFromLines.toFixed(2)),
            valoare_total: Number(totalFromLines.toFixed(2)),
          };

          // Trimitem liniile introduse de utilizator
          const linii = this.liniiRJ
            .filter(l => l && Number(l.suma) > 0 && (l.cont_debit || l.cont_credit))
            .map(l => ({
              cont_debit: l.cont_debit ? String(l.cont_debit).trim() : null,
              cont_credit: l.cont_credit ? String(l.cont_credit).trim() : null,
              suma: Number(l.suma),
              explicatie: l.explicatie ? String(l.explicatie).trim() : ''
            }));

          const { data } = await axios.post('/api/administrare/work/reg-jurnal/save', { antet: antetManual, linii });
          const msg = (data && (data.message || data.msg)) || 'Înregistrarea a fost salvată.';
          Swal.fire({ icon: 'success', title: 'Salvat', text: msg });
          this.hideLucruModal();
          // Refresh tabelul pentru a actualiza coloana RJ
          this.loadFacturi();
        }
      } catch (e) {
        console.error('Eroare salvare RJ', e);
        const errText = e?.response?.data?.error || e?.response?.data?.message || e?.message || 'A apărut o eroare.';
        Swal.fire({ icon: 'error', title: 'Eroare!', text: errText });
      } finally {
        this.savingRJ = false;
      }
    },

    async onProductAccountChange(product, newAccountObj) {
      if (!product || !product.id) return;
      const newVal = newAccountObj ? newAccountObj.cod_complet : null;

      // Optimization: update locally
      product.cont_credit_obj = newAccountObj; // ensure multiselect updates
      product.cont_credit = newVal;
      product.saving = true;

      try {
        await axios.post('/api/administrare/work/facturi/intrare/update-produs-cont', {
          id_produs_intrare: product.id,
          cont_credit: newVal,
          id_firma: this.firmaId
        });

        // After saving, refresh the RJ preview
        await this.fetchRJPreview();

      } catch (e) {
        console.error('Failed to update product account', e);
        Swal.fire({ icon: 'error', title: 'Eroare', text: 'Nu s-a putut salva contul.' });
      } finally {
        product.saving = false;
      }
    },

    async fetchRJPreview() {
      if (!this.modalFactura) return;
      try {
        const resp = await axios.get('/api/administrare/work/reg-jurnal/factura-primita', {
          params: {
            firma_id: this.firmaId,
            document_id: this.modalFactura.id,
            tip_document: this.rjForm.tip_document
          }
        });

        if (!resp.data.exists) {
          this.backendPreviewLines = resp.data.linii_preview || [];
          // If manual mode is active, update liniiRJ
          if (!this.useAutoRJ) {
            this.liniiRJ = this.backendPreviewLines.map(l => ({
              cont_debit: l.cont_debit_cod_complet || l.cont_debit_id,
              cont_credit: l.cont_credit_cod_complet || l.cont_credit_id,
              suma: Number(l.suma_ron || 0),
              explicatie: l.descriere || ''
            }));
          }
        }
      } catch (e) {
        console.error('Preview refresh failed', e);
      }
    },

    showFullName(text, id) {
      if (!text || text === '-' || text === '/') return;

      if (this.tooltipData.visible && this.tooltipData.activeId === id) {
        this.tooltipData.visible = false;
        this.tooltipData.activeId = null;
        return;
      }

      this.tooltipData.text = text;
      this.tooltipData.activeId = id;
      this.tooltipData.visible = true;

      const closeHandler = () => {
        this.tooltipData.visible = false;
        this.tooltipData.activeId = null;
        document.removeEventListener('click', closeHandler);
      };
      setTimeout(() => document.addEventListener('click', closeHandler), 10);
    },

    hydrateProducts(items) {
      if (!Array.isArray(items)) return;
      // Even if planConturi is empty, we should init the property to avoid reactivity issues
      const plan = this.planConturi || [];

      items.forEach(p => {
        // 1. Always reset so we re-match against current planConturi
        p.cont_credit_obj = undefined;

        // 2. Try to match if we have a code and a plan
        if (p.cont_credit && plan.length > 0) {
          const search = String(p.cont_credit).trim();
          const found = plan.find(c => String(c.cod_complet).trim() === search);
          p.cont_credit_obj = found || null;
        } else {
          p.cont_credit_obj = null;
        }
      });
    },

    async loadFacturaUtils() {
      if (this.facturaUtilsLoaded) return;
      this.facturaUtilsLoading = true;
      try {
        const idFirma = this.firmaId;
        const [resSerii, resFurnizori, resValute, resUM, resTipuri, resCote, resPlan] = await Promise.all([
          axios.get(`/api/administrare/work/utils/serii-facturi/${idFirma}`),
          axios.get(`/api/administrare/work/utils/furnizori/${idFirma}`),
          axios.get('/api/administrare/work/utils/valute'),
          axios.get('/api/administrare/work/utils/unitati-masura'),
          axios.get('/api/administrare/work/utils/tipuri-produse'),
          axios.get('/api/administrare/work/utils/cote-tva'),
          axios.get(`/api/administrare/work/utils/plan-conturi/${idFirma}`)
        ]);

        this.seriiFacturi = resSerii.data || [];
        this.listaFurnizori = resFurnizori.data || [];
        this.valute = resValute.data || [];
        this.unitatiMasura = resUM.data || [];
        this.tipuriProduse = resTipuri.data || [];
        this.coteTva = resCote.data || [];
        this.planConturi = resPlan.data || [];

        this.facturaUtilsLoaded = true;
      } catch (e) {
        console.error('Error loading factura utils:', e);
        this.$swal.fire({
          icon: 'error',
          title: 'Eroare',
          text: 'Nu s-au putut încărca utilitarele de facturare.',
        });
      } finally {
        this.facturaUtilsLoading = false;
      }
    },

    async stergeFactura(factura) {
      if (!factura || !factura.id) return;

      const result = await this.$swal.fire({
        title: 'Ești sigur?',
        html: `<p>Factura <b>${factura.serie_doc || ''}${factura.nr_doc || ''}</b> va fi ștearsă definitiv.</p>
               <p class="text-danger fw-bold">Această acțiune este ireversibilă!</p>
               <p class="text-muted small">Se vor șterge: factura, produsele, totalurile, înregistrările din Registrul Jurnal și repartizările de plăți.<br>Fișierul sursă (imaginea) <b>nu</b> va fi șters.</p>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Da, șterge factura!',
        cancelButtonText: 'Anulează',
        reverseButtons: true,
      });

      if (!result.isConfirmed) return;

      try {
        const res = await axios.delete(
          `/api/administrare/work/facturi/intrare/sterge/${factura.id}`,
          { params: { firma_id: this.firmaId } }
        );

        if (res.data.status === 'success') {
          this.$swal.fire({
            icon: 'success',
            title: 'Factură ștearsă!',
            showConfirmButton: false,
            timer: 1500,
          });
          this.loadFacturi();
        } else {
          this.$swal.fire('Eroare', res.data.message || 'Nu s-a putut șterge factura.', 'error');
        }
      } catch (e) {
        console.error('Error deleting invoice:', e);
        this.$swal.fire('Eroare', e.response?.data?.message || 'Nu s-a putut șterge factura.', 'error');
      }
    },

    async salveazaFacturaActualizata() {
      if (!this.facturaForm.id) return;

      this.facturaUtilsLoading = true;
      try {
        const payload = {
          firma_id: this.firmaId,
          factura: this.facturaForm,
          produse: this.facturaProduse,
        };

        const res = await axios.put(
          `/api/administrare/work/facturi/intrare/actualizeaza/${this.facturaForm.id}`,
          payload,
        );

        if (res.data.status === 'success') {
          this.$swal.fire({
            icon: 'success',
            title: 'Factură actualizată!',
            showConfirmButton: false,
            timer: 1500,
          });
          this.editMode = false;
          this.loadFacturi(); // Refresh list
          // Re-open the modal in view mode to reflect changes
          if (this.modalFactura) {
            // Find the updated factura from the list after refresh
            this.$nextTick(() => {
              const updated = this.facturi.find(f => f.id === this.facturaForm.id);
              if (updated) {
                this.modalFactura = updated;
              }
            });
          }
        }
      } catch (e) {
        console.error('Error updating invoice:', e);
        this.$swal.fire('Eroare', e.response?.data?.message || 'Nu s-a putut actualiza factura.', 'error');
      } finally {
        this.facturaUtilsLoading = false;
      }
    },
  }
};
</script>

<style scoped>
#tabel_facturi_primite {
  width: 100% !important;
}

.dt-row-child .table {
  margin-bottom: 0;
}

.table>tbody>tr.child>td {
  padding: 0 !important;
}

/* keep left table tidy */
.modal-body .table td,
.modal-body .table th {
  vertical-align: middle;
}

#tabel_facturi_primite {
  width: 100% !important;
  min-width: 1200px;
  /* Force minimum width to prevent collapsing columns */
}

#tabel_facturi_primite thead th {
  white-space: normal;
  vertical-align: middle;
}

.text-truncate-clickable {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
}

.rotate-up {
  transform: rotate(180deg);
  transition: transform 0.2s;
}

/* Tooltip Finut Style - NESTED approach */
.custom-table-tooltip {
  position: absolute;
  bottom: 125%;
  /* Slight gap */
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  background: #2b2b2b;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
  width: max-content;
  max-width: 320px;
  text-align: center;
  line-height: 1.4;
  pointer-events: none;
  animation: tooltip-fade-in 0.15s ease-out forwards;
  will-change: opacity, transform;
}

.custom-table-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -6px;
  border-width: 6px;
  border-style: solid;
  border-color: #2b2b2b transparent transparent transparent;
}

@keyframes tooltip-fade-in {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
</style>

<style scoped>
.modal-products-scroll {
  /* overflow-x: auto; <--- Removed to allow dropdown overflow */
  /* If table is too wide, modal-xxl should handle it, or we rely on page scroll */
  overflow: visible;
}

/* Use :deep() to penetrate child component scope */
:deep(.small-text-multiselect) {
  font-size: 0.75rem;
}

:deep(.small-text-multiselect .multiselect__tags) {
  min-height: 30px !important;
  padding: 3px 20px 0 8px !important;
  /* more right padding for arrow */
  height: auto !important;
  /* Allow growing */
}

:deep(.small-text-multiselect .multiselect__select) {
  height: 28px !important;
  width: 20px !important;
  padding: 0 !important;
  right: 1px !important;
}

:deep(.small-text-multiselect .multiselect__single) {
  font-size: 0.75rem !important;
  margin-bottom: 0 !important;
  padding-top: 1px !important;
  line-height: 1.25 !important;
  white-space: normal !important;
  /* WRAP TEXT */
  overflow: visible !important;
  height: auto !important;
  word-break: break-word;
  /* Break long words */
}

:deep(.small-text-multiselect .multiselect__input),
:deep(.small-text-multiselect .multiselect__placeholder) {
  font-size: 0.75rem !important;
  margin-bottom: 0 !important;
  padding-top: 1px !important;
}

/* Disabled state visibility improvement */
:deep(.multiselect--disabled) {
  opacity: 1 !important;
  /* Remove transparency */
  background: transparent !important;
}

:deep(.multiselect--disabled .multiselect__tags) {
  background-color: #f9f9f9 !important;
  border-color: #e4e6ef !important;
}

:deep(.multiselect--disabled .multiselect__single) {
  color: #5e6278 !important;
  /* Darker text */
  background: transparent !important;
}

:deep(.small-text-multiselect .multiselect__option) {
  font-size: 0.75rem !important;
  padding: 4px 8px !important;
  min-height: auto !important;
  white-space: normal !important;
  /* Wrap in dropdown too */
}

:deep(.small-text-multiselect .multiselect__option::after) {
  padding: 4px 8px !important;
  line-height: normal !important;
}

/* Remove min-width to prevent bleed with overflow:visible */
.modal-products-scroll>table {
  width: 100%;
  /* min-width: 900px; REMOVED */
}

/* Make the modal even wider than Bootstrap's modal-xl */
#lucruModalFacturiPrimite .modal-dialog.modal-xxl-custom {
  max-width: 95vw;
  width: 95vw;
}

#lucruModalFacturiPrimite .modal-content {
  border-radius: 0.75rem;
}
</style>